import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M104 43c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#D8FFFF"
      d="M104 17.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M7.5 73a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      d="M85 9.5h-5.5V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.5H71c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.5V18c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.5H85c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M25.5 94.6l3.89-3.89c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.89 3.89-3.89-3.89a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.89 3.89-3.89 3.89a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.89-3.89 3.89 3.89c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path
      fill="#D8FFFF"
      d="M92 58c0 8.8-3.37 16.79-8.86 22.83L70.36 68.04c2.23-2.74 3.56-6.23 3.56-10.04 0-4.59-1.95-8.74-5.06-11.65l12.76-12.77C88.01 39.76 92 48.41 92 58"
    />
    <path
      fill="#00D8D8"
      d="M83.14 80.83C76.92 87.67 67.98 92 58 92s-18.24-3.99-24.42-10.38l12.77-12.77A15.88 15.88 0 0 0 58 73.92c4.99 0 9.44-2.29 12.36-5.88z"
    />
    <path
      fill="#D8FFFF"
      d="m35.17 32.86 12.78 12.78c-3.58 2.93-5.87 7.38-5.87 12.36 0 4.2 1.62 8.01 4.27 10.85L33.58 81.62C27.66 75.51 24 67.19 24 58c0-9.98 4.33-18.92 11.17-25.14"
    />
    <path
      fill="#00D8D8"
      d="M47.96 45.64c2.74-2.23 6.23-3.56 10.04-3.56 4.2 0 8.01 1.62 10.85 4.27h.01l12.76-12.77C75.51 27.66 67.19 24 58 24s-16.79 3.37-22.83 8.86l12.78 12.78z"
    />
  </svg>
);
const SvgEnrichedIconHelpCenterBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconHelpCenterBrand);
export default Memo;
